import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdOauthMcpSettingsRedirectUrisCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/oauth_mcp_settings",
];
